import { render, staticRenderFns } from "./seeMoreNz.vue?vue&type=template&id=0a0c097c&scoped=true&"
import script from "./seeMoreNz.vue?vue&type=script&lang=js&"
export * from "./seeMoreNz.vue?vue&type=script&lang=js&"
import style0 from "./seeMoreNz.vue?vue&type=style&index=0&id=0a0c097c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a0c097c",
  null
  
)

export default component.exports